<div class="orca-dialog">
    <div class="dialog-header">
        <h1 class="dialog-title">Dados da Empresa</h1>

        <div class="dialog-btn-close">
            <button mat-icon-button (click)="skip()" aria-label="Fechar">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <div class="dialog-content" *ngIf="!isLoading">
        <p class="dialog-subtitle">
            Nos conte um pouco sobre sua empresa
        </p>

        <form [formGroup]="form" class="company-profile-form">
            <mat-form-field appearance="outline" class="w-100-p">
                <mat-label>Ramo de Atividade</mat-label>
                <mat-select formControlName="business_sector_code" placeholder="Selecione o ramo de atividade">
                    <mat-option
                        *ngFor="let sector of businessSectors"
                        [value]="sector.code">
                        {{ sector.name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('business_sector_code')?.hasError('required')">
                    Campo obrigatório
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100-p">
                <mat-label>Quantidade de Colaboradores</mat-label>
                <mat-select formControlName="employee_count" placeholder="Selecione a faixa">
                    <mat-option *ngFor="let count of employeeCounts" [value]="count.value">
                        {{ count.label }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('employee_count')?.hasError('required')">
                    Campo obrigatório
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100-p">
                <mat-label>Seu Cargo</mat-label>
                <mat-select formControlName="user_job_title" placeholder="Selecione seu cargo">
                    <mat-option *ngFor="let title of jobTitles" [value]="title.value">
                        {{ title.label }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('user_job_title')?.hasError('required')">
                    Campo obrigatório
                </mat-error>
            </mat-form-field>
        </form>
    </div>

    <div class="dialog-content loading-container" *ngIf="isLoading">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Carregando...</p>
    </div>

    <div class="dialog-footer" *ngIf="!isLoading">
        <div class="dialog-actions">
            <button class="btn btn-gray" (click)="skip()" [disabled]="isSaving">
                Pular
            </button>

            <button class="btn btn-blue" (click)="save()" [disabled]="isSaving || form.invalid">
                <mat-spinner *ngIf="isSaving" diameter="20"></mat-spinner>
                <span *ngIf="!isSaving">Salvar</span>
            </button>
        </div>
    </div>
</div>
